import { render, staticRenderFns } from "./expense-type-modal.vue?vue&type=template&id=5dd413e9&scoped=true&"
import script from "./expense-type-modal.vue?vue&type=script&lang=js&"
export * from "./expense-type-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd413e9",
  null
  
)

export default component.exports